import { useEffect, useState } from "react";
import ProductionSelectionArea from "./components/ProductionSelectionArea";
import TableArea from "./components/TableArea";
import { getCurrentYearAndMonth, toTitleCase } from "@utils/helpers";
import {
  useFetchSidebarProductsQuery,
  useFetchSidebarProductsSubsectionListQuery,
} from "@store/products";
import { REGULATORY_FILLING } from "./data/activeTabs";

export default function ProductInsights() {
  const [activeProduct, setActiveProduct] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [hiddenSidebar, setHiddenSidebar] = useState(false);

  const [selectedDate, setselectedDate] = useState(
    `${toTitleCase(getCurrentYearAndMonth().month)} ${
      getCurrentYearAndMonth().year
    }`,
  );

  const {
    data: sidebarProductsSubsectionList,
    isLoading: isSidebarProductsSubsectionListLoading,
    isFetching: isSidebarProductsSubsectionListFetching,
  } = useFetchSidebarProductsSubsectionListQuery(
    {
      ProductId: activeProduct,
      month: selectedDate?.split(" ")[0].toLowerCase(),
      year: selectedDate?.split(" ")[1],
    },
    { skip: !activeProduct, refetchOnMountOrArgChange: true },
  );

  const {
    data: sidebarProducts,
    isLoading: isSidebarProductsLoading,
    isFetching: isSidebarProductsFetching,
  } = useFetchSidebarProductsQuery({
    month: selectedDate?.split(" ")[0].toLowerCase(),
    year: selectedDate?.split(" ")[1],
  });

  const updateQueryWithTabChange = (product, tab = null) => {
    setActiveProduct(Number(product));
    if (tab) {
      setActiveTab(Number(tab));
    } else {
      setActiveTab(null);
    }
  };

  const getTableAreaLabel = () => {
    let label = "Select a Product";

    const subSection = sidebarProductsSubsectionList?.list?.find(
      (t) => t.id === activeTab,
    )?.displayName;

    const product = sidebarProducts?.productList?.find(
      (t) => t.id === activeProduct,
    );
    const productName = product?.name;
    const isRDProduct = product?.["isR&D"];

    // if active tab is reg. filing we will display product name
    if (hiddenSidebar) {
      label = `${subSection} - ${productName} ${isRDProduct ? "(R&D)" : ""}`;
    } else {
      // show whichever tab is selected whether it's product or sub-product
      label = subSection
        ? subSection
        : productName
          ? `${productName} ${isRDProduct ? "(R&D)" : ""}`
          : label;
    }

    return label;
  };

  useEffect(() => {
    if (activeProduct) {
      setActiveTab(null);
      setselectedDate(
        `${toTitleCase(getCurrentYearAndMonth().month)} ${
          getCurrentYearAndMonth().year
        }`,
      );
    }
  }, [activeProduct]);

  return (
    <div className="h-full flex md:flex-row flex-col gap-2.5 p-2 overflow-x-hidden overflow-y-auto rounded-lg md:p-5 animate-fadeIn bg-secondary-main custom-scrollbar">
      {/* Production Selection Area */}
      <ProductionSelectionArea
        activeProduct={activeProduct}
        activeTab={activeTab}
        updateQueryWithTabChange={updateQueryWithTabChange}
        productList={
          sidebarProducts?.productList ? sidebarProducts?.productList : []
        }
        subsectionList={
          sidebarProductsSubsectionList?.list
            ? sidebarProductsSubsectionList?.list
            : []
        }
        isLoading={
          isSidebarProductsSubsectionListLoading ||
          isSidebarProductsLoading ||
          isSidebarProductsSubsectionListFetching ||
          isSidebarProductsFetching
        }
        hiddenSidebar={hiddenSidebar}
        setHiddenSidebar={setHiddenSidebar}
      />
      {/* Table Area */}
      <TableArea
        label={getTableAreaLabel()}
        selectedDate={selectedDate}
        setselectedDate={setselectedDate}
        activeProduct={activeProduct}
        activeTab={activeTab}
        productsList={sidebarProducts?.productList}
        subsectionList={sidebarProductsSubsectionList?.list}
        isProductListEmpty={
          sidebarProducts?.productList
            ? sidebarProducts?.productList.length === 0
            : sidebarProductsSubsectionList?.list
              ? sidebarProductsSubsectionList?.list?.length === 0
              : false
        }
        setHiddenSidebar={setHiddenSidebar}
        hiddenSidebar={hiddenSidebar}
      />
    </div>
  );
}
